module.exports = __webpack_public_path__ + "img/c4-bg.8ef1f0f3.jpg";